import React, { useEffect, useState } from 'react';
import { useShop } from '../contexts/ShopContext';
import { getShopContent } from '../api';
import ShopSidebarRight from '../components/ShopSidebarRight';
import { useLanguage } from '../i18n';

/** Mobile/tablet page for the owner's videos (desktop shows them in the right sidebar). */
export default function VideosPage() {
  const { shop } = useShop();
  const { t } = useLanguage();
  const [videos, setVideos] = useState([]);
  const shopId = (shop && shop.id) || null;

  useEffect(() => {
    if (!shopId) return;
    getShopContent(shopId)
      .then((c) => setVideos(Array.isArray(c.videos) ? c.videos : []))
      .catch(() => setVideos([]));
  }, [shopId]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-6">
      <h1 className="text-xl font-bold mb-4" style={{ color: 'var(--primary)' }}>{t('videos')}</h1>
      <ShopSidebarRight videos={videos} />
    </div>
  );
}
